"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Collection;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    section: {
      marginTop: theme.spacing(5),
      textAlign: "center"
    },
    paginator: {
      padding: 0,
      color: theme.palette.text.secondary,
      display: "flex",
      "& li": {
        display: "inline-block",
        flex: 1,
        margin: theme.spacing(2),
        " & a": {
          cursor: "pointer"
        }
      },
      width: "100%"
    },
    page: {},
    active: {
      color: theme.palette.primary.main,
      fontWeight: "bold"
    },
    link: _objectSpread({}, theme.typography.caption, {
      textAlign: "center",
      margin: "0 auto"
    }),
    searchField: {
      width: "85%"
    }
  };
});
/**
 * Collection component.
 */

function Collection(props) {
  var count = props.count,
      description = props.description,
      loading = props.loading,
      name = props.name,
      onSearch = props.onSearch,
      onSearchInput = props.onSearchInput,
      search = props.search,
      stories = props.stories,
      onPageChange = props.onPageChange,
      page = props.page,
      pageCount = props.pageCount,
      q = props.q,
      _props$urlFormatter = props.urlFormatter,
      urlFormatter = _props$urlFormatter === void 0 ? "$id" : _props$urlFormatter;
  var classes = useStyles();

  var renderCard = function renderCard(_ref, index) {
    var description = _ref.description,
        id = _ref.id,
        image = _ref.image,
        label = _ref.label;
    var url = urlFormatter.replace('$id', id);
    var key = "".concat(index, "-").concat(id);
    return _react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 10,
      md: 4,
      xl: 3,
      key: key
    }, _react.default.createElement(_core.Card, null, image && _react.default.createElement(_core.CardMedia, {
      component: "img",
      image: image,
      title: "image of ".concat(label)
    }), _react.default.createElement(_core.CardContent, null, _react.default.createElement(_core.Typography, {
      variant: "h5"
    }, label), _react.default.createElement(_core.Typography, {
      color: "secondary",
      variant: "overline"
    }, description)), _react.default.createElement(_core.CardActions, null, _react.default.createElement(_core.Grid, {
      container: true,
      justify: "space-between"
    }, _react.default.createElement(_core.Grid, {
      item: true
    }, _react.default.createElement(_core.Button, {
      color: "primary",
      size: "small",
      href: url
    }, "Learn More")), _react.default.createElement(_core.Grid, {
      item: true
    }, _react.default.createElement(_core.Typography, {
      color: "textSecondary",
      variant: "overline"
    }, id))))));
  };

  var renderPagination = function renderPagination() {
    return _react.default.createElement(_reactPaginate.default, {
      previousLabel: "previous",
      nextLabel: "next",
      breakLabel: "...",
      breakClassName: "break-me",
      pageCount: pageCount,
      marginPagesDisplayed: 2,
      pageRangeDisplayed: 5,
      initialPage: page - 1,
      onPageChange: onPageChange,
      containerClassName: classes.paginator,
      pageClassName: classes.page,
      activeClassName: classes.active
    });
  };

  return _react.default.createElement(_core.Grid, {
    container: true,
    justify: "center"
  }, _react.default.createElement(_core.Grid, {
    item: true,
    xs: 10,
    className: classes.section
  }, _react.default.createElement(_core.Typography, {
    variant: "h2",
    color: "primary"
  }, name), description && _react.default.createElement(_core.Typography, {
    variant: "h6",
    color: "textSecondary"
  }, description), count ? _react.default.createElement(_core.Typography, {
    variant: "overline",
    color: "textSecondary"
  }, count, " Stor", count === 1 ? "y" : "ies", " in this Collection", q && "found with keyword '".concat(q, "'")) : null), onSearch && _react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.section
  }, _react.default.createElement("form", {
    onSubmit: onSearch
  }, _react.default.createElement(_core.TextField, {
    className: classes.searchField,
    label: "Search Collection...",
    value: search,
    onChange: onSearchInput
  }))), _react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, _react.default.createElement(_core.Divider, null), loading && _react.default.createElement(_core.LinearProgress, {
    variant: "query"
  })), _react.default.createElement(_core.Grid, {
    item: true,
    xs: 10,
    className: classes.section
  }, _react.default.createElement(_core.Grid, {
    container: true,
    justify: "center",
    spacing: 3
  }, loading || stories.length ? stories.map(renderCard) : _react.default.createElement(_core.Typography, {
    variant: "overline"
  }, "No More Stories Found in this Collection."))), _react.default.createElement(_core.Grid, {
    item: true,
    xs: 8,
    className: classes.section
  }, pageCount > 1 && renderPagination()), _react.default.createElement(_core.Grid, {
    item: true,
    xs: 8,
    className: classes.section
  }, _react.default.createElement(_core.Button, {
    target: "_blank",
    color: "secondary",
    size: "small",
    className: classes.link,
    href: _constants.STORIES_API_HOMEPAGE
  }, "POWERED BY THE STORIES SERVICE")));
}